import { api } from '../api'

export const gradesApi = api
  .enhanceEndpoints({
    addTagTypes: [
      'GetGrades',
      'GetUserGrades',
      'UsersGradesTasks',
      'ExportGrade',
    ],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      getGradesList: builder.query({
        providesTags: ['projectType'],
        query: () => {
          return {
            url: `/grade-directions`,
            method: 'GET',
          }
        },
        transformResponse: (response) => response?.data || [],
      }),
      getUserGrade: builder.query({
        query: (userId) => {
          return {
            url: `/user-grade/${userId}`,
            method: 'GET',
          }
        },
        transformResponse: (response) => response?.data || [],
      }),
      getUserGradesTasks: builder.query({
        providesTags: ['UsersGradesTasks'],
        query: (userId) => {
          return {
            url: `/user-grade/list/${userId}`,
            method: 'GET',
          }
        },
        transformResponse: (response) => response?.data || [],
      }),
      ExportGrade: builder.query({
        providesTags: ['ExportGrade'],
        query: (gradeId) => {
          return {
            url: `/grades/${gradeId}/export-items`,
            method: 'GET',
          }
        },
        transformResponse: (response) => response,
      }),
      importGrade: builder.mutation({
        query: ({ gradeId, file }) => {
          const formData = new FormData()
          formData.append('file', file)

          return {
            url: `/grades/${gradeId}/import-items`,
            method: 'POST',
            body: formData,
          }
        },
      }),
    }),
  })

export const {
  useGetGradesListQuery,
  useGetUserGradeQuery,
  useGetUserGradesTasksQuery,
  useLazyExportGradeQuery,
  useImportGradeMutation,
} = gradesApi
